import { useOpstelClient } from "@opstel/contexts/opstelClient/useOpstelClient";
import { CreateInstanceRequest } from "@opstel/query/v2/opstelClient";
import { useCurrentInstanceId } from "@shared/common/contexts/instanceMetadata/useInstanceId";
import { useKnopIsLoading } from "@shared/common/hooks/useKnopIsLoading";
import { messageToast } from "@shared/EDS/components/MessageToast/messageToastFunctions";
import { useMutation } from "@tanstack/react-query";

export function useCreateInstanceMutation() {
  const { opstelClient } = useOpstelClient();
  const setLoading = useKnopIsLoading((state) => state.setLoading);
  const setReady = useKnopIsLoading((state) => state.setReady);
  const { setCurrentInstanceId } = useCurrentInstanceId();

  return useMutation({
    mutationFn: (request: CreateInstanceRequest) => opstelClient.createInstance(request),
    onMutate: () => {
      setLoading();
    },
    onSettled: () => setReady(),
    onSuccess: (data) => {
      setCurrentInstanceId(data.instanceId);
    },
    onError: (err) => {
      console.error(err);
      messageToast({
        message: "Het laden van het scenario is mislukt.",
        type: "error",
      });
    },
  });
}
